import(/* webpackMode: "eager" */ "/app/frontend/src/app/error.tsx");
